// isAndroid
export default (function() {
  return navigator.userAgent.toLowerCase().indexOf('android') !== -1;
})();
